import _ from 'lodash';

const ATTRIBUTES = [
  { handle: 'year', name: 'Year', preference: 0 },
  { handle: 'vehicleDescription', name: 'Vehicle Description', preference: 1 },
  { handle: 'bodyStyle', name: 'Body Style', preference: 2 },
  { handle: 'transmission', name: 'Transmission', preference: 3 },
  { handle: 'fuelType', name: 'Fuel Type', preference: 4 },
  { handle: 'series', name: 'Series', preference: 5 },
  { handle: 'badgeDescription', name: 'Badge Description', preference: 6 },
  { handle: 'engineDisplacement', name: 'Engine Displacement', preference: 7 },
];

const DEFAULT_ATTRIBUTE = _.find(ATTRIBUTES, { preference: 1 });
const STATIC_ATTRIBUTE = _.find(ATTRIBUTES, { preference: 0 });
const OPTIONS_LIMIT = 10;
const FILTERS_LIMIT = 3;

export { ATTRIBUTES, DEFAULT_ATTRIBUTE, STATIC_ATTRIBUTE, OPTIONS_LIMIT, FILTERS_LIMIT };
